// extracted by mini-css-extract-plugin
module.exports = {"search_button":"SearchButton_search_button__qkyig","search":"SearchButton_search__s_BV_"};